import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ProgressBar from 'common-components/ProgressBar';
import { useAuth } from './useAuth';
import { getAzureLocation } from './api';
import Alert from 'common-components/Alert';

import './login.style.css';

const Login = () => {
  const auth = useAuth();
  const { state } = useLocation();
  const [alertData, setAlertData] = useState({});

  const initiateLogin = async () => {

    if (state && state.from) {
      localStorage.setItem('__PREV_PATH__', state.from.pathname);
    };

    let loginResponse = await getAzureLocation();
    if (loginResponse) loginResponse = JSON.parse(loginResponse);
    else {
      setAlertData({
        title: 'Login Failed',
        description: 'Got server error. Kindly contact WPV team',
        eventName: 'Close',
        showModal: true,
        type: 'error'
      });
      return;
    };

    localStorage.setItem('__AZURE_STATE__', loginResponse.azure_state);
    window.location.href = loginResponse.azure_login_location;
  };

  useEffect(() => {
    if (!auth.token) {
      initiateLogin();
    }
  }, []);

  return (
    <>
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
      <div className='progress-bar-container'>
        < ProgressBar
          done='50'
          timeout='700'
          message='Redirecting to Azure ..'
        />
      </div>
    </>
  )
};

export default Login;